const container = document.querySelector('.three-grid__container');
const bar = document.querySelector('.three-grid__progress-bar');
const slides = document.querySelectorAll('.three-grid__box');

if (container && bar && slides.length) {
  const totalSlides = slides.length;

  const updateProgress = () => {
    const maxScroll = container.scrollWidth - container.clientWidth;

    let activeIndex = 0;

    if (maxScroll > 0) {
      activeIndex = Math.round(
        (container.scrollLeft / maxScroll) * (totalSlides - 1)
      );
    }

    const progress = ((activeIndex + 1) / totalSlides) * 100;
    bar.style.width = `${progress}%`;
  };

  container.addEventListener('scroll', updateProgress);
  window.addEventListener('resize', updateProgress);

  updateProgress();
}
